let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9eAO5")).then(() => parcelRequire('3eJc8'));